import MangaCard from '@/components/base/MangaCard';
import { getTopRatedManga } from '@/mocks/manga';

export default function Ranking() {
  const topManga = getTopRatedManga(10);

  const topThree = topManga.slice(0, 3);
  const restManga = topManga.slice(3);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">高分漫画排名，品质之选</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-8">
          {topThree.map((manga, index) => (
            <div key={manga.id} className="relative">
              <div className="absolute -top-3 -left-3 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-white font-bold text-sm">
                {index + 1}
              </div>
              <MangaCard manga={manga} variant="featured" />
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl p-4 md:p-6 divide-y divide-background-200/70">
          {restManga.map((manga) => (
            <MangaCard key={manga.id} manga={manga} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}